'use strict';

export default function ApplicationConfigFactory() {
  const config = {
    'emailSupport': 'support@viralstyle.com',
    'clientSupport': 'clientsupport@viralstyle.com',
    'shopifySupport': 'shopify@viralstyle.com',
    'legalEmail': 'legal@viralstyle.com',

    'phone': '1-888-491-8876',

    'viralstyleShippingAddress': '601 N Ashley Drive Suite 500',
    'viralstyleShippingCity': 'Tampa',
    'viralstyleShippingState': 'FL',
    'viralstyleShippingZip': '33602',

    'viralstyleMailingAddress': '301 W. Platt Street Suite 47',
    'viralstyleMailingCity': 'Tampa',
    'viralstyleMailingState': 'FL',
    'viralstyleMailingZip': '33606-2292'

  };

  return {
    getConfig: function getconfig() {
      return config;
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/data-providers/config.js